import { defineComponent as _defineComponent } from 'vue'
import InputGroup from '@/components/form/InputGroup.vue';
import IconMessageBlock from '@/components/info/IconMessageBlock.vue';
import TooltipIconClick from '@/components/info/TooltipIconClick.vue';
import Checkbox from '@/components/inputs/Checkbox.vue';
import FetchAutoComplete from '@/components/inputs/FetchAutoComplete.vue';
import TextArea from '@/components/inputs/TextArea.vue';
import { Icon } from '@/lib/enum/Icon';
import { Entity } from '@/lib/realtime/RealtimeEntity';
import { realtimeQuery } from '@/lib/realtime/weak/realtimeFunctions';
import { ShiftAdvancedOptionsFormType } from '@/types/shiftAdvancedOptions';
import useVuelidate from '@vuelidate/core';
import { reactive, ref, watch } from 'vue';
import { Shift } from '../../../api/v1';


export default /*#__PURE__*/_defineComponent({
  __name: 'ShiftAdvancedOptions',
  props: {
    shift: { default: null },
    advancedOptions: null,
    updateAdvancedOptions: null
  },
  setup(__props: any) {

const props = __props as { shift: Shift | null, advancedOptions: ShiftAdvancedOptionsFormType, updateAdvancedOptions: (v: ShiftAdvancedOptionsFormType) => void }



const tagQuery = ref('');
const tags = reactive(realtimeQuery(Entity.Tag).whereActive().fetch());

const form = reactive<ShiftAdvancedOptionsFormType>({
  ...props.advancedOptions,
});
const validations = {
  showEndTime: {},
  showJobRole: {},
  tags: {},
  notes: {},
};
const v$ = useVuelidate(validations, form, { $autoDirty: true });

watch(form, (newValues) => {
  props.updateAdvancedOptions(newValues);
});

return { __sfc: true,props, tagQuery, tags, form, validations, v$, InputGroup, IconMessageBlock, TooltipIconClick, Checkbox, FetchAutoComplete, TextArea, Icon }
}

})